import axios from "axios";
import localforage from "localforage"
import configData from "../config"
let api_url = configData.API_URL || "http://localhost:8080/"

class AuthServ {
    login(username, password) {
        console.log(api_url)
        return axios.post(api_url + "login", { username: username, password: password })
            .then(res => {
                if (res.data.token) {
                    localStorage.setItem("token", res.data.token);
                    localStorage.setItem("username", res.data.username);
                    return localforage.setItem("preferences", res.data.preferences).then(() => {
                        return localforage.setItem("notifications", res.data.notifications).then(() => {
                            return localforage.setItem("coinAboveLimits", []).then(() => {
                                return localforage.setItem("coinBelowLimits", []).then(() => {
                                    return res.data
                                })
                            })
                        })
                    })
                }
                else {
                    return res.data
                }
            });
    }

    logout() {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localforage.clear();
    }

    signup(username, password, email) {
        return axios.post(api_url + "signup", { username: username, password: password, email: email })
            .then(res => {
                return res.data
            })
    }

    getUser() {
        return localStorage.getItem("username");
    }

}

export default new AuthServ()